export default theme => ({
  table: {
    marginTop: theme.spacing.unit * 2,
  },
})
